import * as React from "react";
const SvgSlash = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 1.5, d: "M14.363 7.997 10.771 15.7" }));
export default SvgSlash;
